import { useEffect, useMemo, useState } from "react";

import { useDropzone } from "react-dropzone";

import { Spinner } from "react-bootstrap";

import { BsUpload } from "react-icons/bs";

import { useGallery, useLoader } from "../../../hooks";

import CustomGallery from "../../gallery";
import { validateImage } from "../../../helpers";
import { Button, ConfirmDialog } from "../../decorate";
import { CiWarning } from "react-icons/ci";

const allowedFormats = ["jpg", "jpeg", "png", "pdf"];
const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  jusifyContentL: "center",
  color: "#fff",
  outline: "none",
  width: 180,
  height: 180,
  margin: "auto",
};
const focusedStyle = {
  borderColor: "#2196f3",
};
const acceptStyle = {
  borderColor: "#00e676",
};
const rejectStyle = {
  borderColor: "#ff1744",
};

const CustomUpload = ({ isGallery = false, logo_url, handleUrls }) => {
  const [error, setError] = useState({ msg: "", isOpen: false });
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
    acceptedFiles,
  } = useDropzone({
    accept: {
      "image/*": [],
      "application/pdf": [],
    },
    maxFiles: 1,
    multiple: false,
  });

  const { setUploadedImages } = useGallery();
  const { onLoader, offLoader } = useLoader();
  const [isLoading, setIsLoading] = useState(false);
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject],
  );

  // const handleUpload = async () => {
  //   const { error, isValid } = validateImage(acceptedFiles[0], allowedFormats);

  //   if (!isValid) {
  //     const msg =
  //       error === "size"
  //         ? "The file size exceeds the 5MB limit. Please upload a smaller file."
  //         : "Unsupported file format. Please upload a JPG, JPEG, PNG, or PDF file.";
  //     setError({
  //       msg,
  //       isOpen: true,
  //     });

  //     return;
  //   }

  //   try {
  //     onLoader();
  //     setIsLoading(true);
  //     await setUploadedImages(acceptedFiles[0], (url) => {
  //       handleUrls({
  //         logo_url: url,
  //         cropped_url: url,
  //       });
  //     });
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setIsLoading(false);
  //     offLoader();
  //   }
  // };

  const handleUpload = () => {
    const { error, isValid } = validateImage(acceptedFiles[0], allowedFormats);

    if (!isValid) {
      const msg =
        error === "size"
          ? "The file size exceeds the 5MB limit. Please upload a smaller file."
          : "Unsupported file format. Please upload a JPG, JPEG, PNG, or PDF file.";
      setError({
        msg,
        isOpen: true,
      });

      return;
    }

    onLoader();
    setIsLoading(true);
    setUploadedImages(acceptedFiles[0], (url) => {
      handleUrls({
        logo_url: url,
        cropped_url: url,
      });
    });

    setIsLoading(false);
    offLoader();
  };

  useEffect(() => {
    if (acceptedFiles?.[0]) handleUpload();
  }, [acceptedFiles[0]]);

  return (
    <>
      {!isGallery && (
        <div className="uploadSection">
          <div className="draggableFileUpSec">
            <div {...getRootProps({ style })}>
              <input {...getInputProps()} />

              <div className="m-auto d-flex align-items-center justify-content-center">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <div
                    className="text-center"
                    style={{
                      backgroundColor: "#FFFFFFB2",
                      color: "#666666",
                      borderRadius: "20%",
                      fontSize: 20,
                      padding: "8px 13px",
                    }}
                  >
                    {isLoading ? (
                      <Spinner style={{ borderWidth: 1 }} />
                    ) : (
                      <BsUpload />
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: 500,
                      textAlign: "center",
                    }}
                  >
                    {acceptedFiles[0]
                      ? acceptedFiles[0].name
                      : "Upload your file here"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="">
        <CustomGallery
          logo_url={logo_url}
          handleUrls={handleUrls}
          style={{ ...(isGallery ? { maxHeight: 300 } : {}) }}
        />
      </div>

      {error?.isOpen && (
        <ConfirmDialog
          icon={<CiWarning size={22} />}
          isOpen={error?.isOpen}
          title={<span style={{ color: "#f2b843" }}>Warning</span>}
          footerStyle={{ justifyContent: "center" }}
          footer={
            <Button
              label="OK"
              variant="primary"
              size="small"
              onClick={() => setError({ msg: "", isOpen: false })}
              style={{
                padding: "10px 15px",
                fontSize: 15,
              }}
            />
          }
        >
          <div className="text-center">{error?.msg}</div>
        </ConfirmDialog>
      )}
    </>
  );
};

export default CustomUpload;
